import React, { Component } from 'react';
import styled from 'styled-components';

import enhanceWithClickOutside from 'react-click-outside';
import { NavLink } from 'react-router-dom';
import { Flex, media } from 'lib/style-utils';

/** Mobile Menu */
const Mobile = Flex.extend`
  display: none;
  background: #ffffff;
  position: fixed;
  top: -493px;
  left: 0;
  width: 100%;
  height: 493px;
  box-sizing: border-box;
  z-index: 25;
  transform: ${props =>
    props.showMenu ? 'translateY(493px)' : 'translateY(-493px)'};
  transition: all 0.4s ease-in-out;

  ${media.tablet`
    display: inline-block;
  `};
`;

const Menu = Flex.extend`
  width: 100%;
  height: 247px;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 68px;
  border-top: 1px solid #d5d5d5;

  ${media.mobile`
    margin-top: 76px;
  `} & > a {
    margin: 18px auto;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 0.4px;
    color: #424242;
    transition: all 0.3s;
  }
`;

/** Mobile Link Button */
const BtnNav = Flex.extend`
  width: 360px;
  height: 45px;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;

  ${media.w1440`
    width: 315px;
  `}
  ${media.w1200`
    width: 260px;
  `}
  ${media.tablet`
    display: none;
  `}
`;

const MobileBtn = BtnNav.extend`
  display: none;

  ${media.tablet`
    display: flex;
    width: 90%;
    height: 180px;
    margin: 0 auto;
    padding-top: 0;
    border-top: 1px solid #d5d5d5;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > button {
      margin-top: 20px;
    }
    ${media.mobile`
      height: 165px;
    `}
  `} & > a:last-child {
    margin-top: 20px;
  }
`;

const Btn = styled.button`
  display: inline-block;
  padding: 0px 30px;
  height: 45px;
  background: #ffffff;
  color: #999999;
  border: 1px solid #eeeeee;
  border-radius: 23px;
  text-align: center;
  font-size: 15px;
  letter-spacing: 1.2px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
  }

  ${media.tablet`
    padding: 0px 32px;
  `} ${media.mobile`
    padding: 0px 29px;
  `};
`;

class MobileMenu extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  handleClickOutside = () => {
    this.props.hideMenu();
  };

  render() {
    const { showMenu, handleClick } = this.props;

    return (
      <Mobile showMenu={showMenu}>
        <Menu>
          <NavLink to="/about" onClick={handleClick}>
            ABOUT
          </NavLink>
          <NavLink to="/lookbook" onClick={handleClick}>
            LOOK BOOK
          </NavLink>
          <NavLink to="/shoplist" onClick={handleClick}>
            SHOP LIST
          </NavLink>
          <NavLink to="/contact" onClick={handleClick}>
            CONTACT
          </NavLink>
        </Menu>

        <MobileBtn>
          <a
            href="http://www.gurmbyh.com/product/list.html?cate_no=115"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Btn>SHOP</Btn>
          </a>
          <a
            href="http://www.gurmbyh.co.jp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Btn>GO JAPAN</Btn>
          </a>
        </MobileBtn>
      </Mobile>
    );
  }
}

export default enhanceWithClickOutside(MobileMenu);



// WEBPACK FOOTER //
// ./src/components/Shared/MobileMenu.js